import styled from 'styled-components'

export const PatientCaseDescriptionContainer = styled.div`
  width: 100%;

  > p {
    margin: 5px 0 10px;
  }
`

export const ContentLabel = styled.div`
  display: flex;
  justify-content: space-between;

  svg {
    cursor: pointer;
  }
`

export const TextAreaLengthDisplay = styled.div`
  display: flex;
  justify-content: flex-end;

  margin-top: 10px;

  p {
    color: #898989;
  }
`
